import { Column, Entity, Index, PrimaryGeneratedColumn } from 'typeorm';

/**
 * Stores periodic compliance KPI snapshots for dashboard display and trend analysis.
 *
 * - Rows with snapshot_date = NULL are "live" refreshes (latest KPI state, every 15 min)
 * - Rows with snapshot_date set are daily snapshots for 90-day trend sparklines
 * - The REFRESH_COMPLIANCE_STATS job on LICENSE_MATCHMAKER queue populates this
 */
@Index('idx_snapshot_date', ['snapshotDate'], { unique: true })
@Index('idx_computed_at', ['computedAt'])
@Entity('license_compliance_snapshot')
export class LicenseComplianceSnapshotEntity {
	@PrimaryGeneratedColumn({ name: '_id', unsigned: true })
	public id!: number;

	@Column('date', { name: 'snapshot_date', nullable: true })
	public snapshotDate!: string | null;

	@Column('int', { name: 'pending_match', default: 0 })
	public pendingMatch!: number;

	@Column('int', { name: 'expiring_soon', default: 0 })
	public expiringSoon!: number;

	@Column('int', { name: 'expired', default: 0 })
	public expired!: number;

	@Column('int', { name: 'at_risk', default: 0 })
	public atRisk!: number;

	@Column('int', { name: 'recently_changed', default: 0 })
	public recentlyChanged!: number;

	@Column('int', { name: 'total_licenses', default: 0 })
	public totalLicenses!: number;

	@Column('int', { name: 'matched_to_registry', default: 0 })
	public matchedToRegistry!: number;

	@Column('int', { name: 'with_files', default: 0 })
	public withFiles!: number;

	@Column('char', { name: 'health_score', length: 1, nullable: true })
	public healthScore!: string | null;

	@Column('datetime', {
		name: 'computed_at',
		default: () => 'CURRENT_TIMESTAMP',
	})
	public computedAt!: Date;

	@Column('datetime', {
		name: '_created_date',
		default: () => 'CURRENT_TIMESTAMP',
	})
	public createdDate!: Date;
}
